export { default } from "./CompanySearchResults";



// WEBPACK FOOTER //
// ./src/components/client-search/CompanySearchResults/index.js